import React from 'react';
import styled from '@benzinga/themetron';
import { runningClientSide } from '@benzinga/utils';

export interface WidgetProps {
  context_id: string;
}

export const DianomiBlock: React.FC<WidgetProps> = ({ context_id }) => {
  if (!context_id) {
    return null;
  }

  if (runningClientSide()) {
    const script = document.querySelector('#dianomi-script');
    if (script) {
      script.remove();
    }

    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://www.dianomi.com/js/contextfeed.js';
    scriptElement.setAttribute('async', 'true');
    scriptElement.setAttribute('id', 'dianomi-script');

    scriptElement.onerror = (event: string | Event) => {
      if (typeof event === 'object' && event.type === 'error') {
        console.error('Failed to load Dianomi');
      }
    };

    document.body.appendChild(scriptElement);
  }

  return (
    <WidgetWrapper>
      <div className="dianomi_context" data-dianomi-context-id={context_id}></div>
    </WidgetWrapper>
  );
};

export const WidgetWrapper = styled.div`
  margin: 16px 0;
`;
